/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <!-- Left: switcher + checklist -->
      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='r1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r1'">R1</vs-button>
          <vs-button :color="sel==='r2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r2'">R2</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Tasks 1-3 (both routers) -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task123Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task123Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task123Done?'#28C76F':'#4a5568'}">1-3</span>
              <span class="font-semibold text-sm flex-1">IPv4 Interface Configuration</span>
              <span class="text-xs font-medium" :class="task123Done?'text-success':'text-grey'">{{ task123Progress }}/6</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="rKey in ['r1','r2']" :key="'t123-'+rKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ rKey.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task123Items" :key="rKey+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getCompletion(rKey)[item.key]?'#28C76F':'transparent',border:'2px solid '+(getCompletion(rKey)[item.key]?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getCompletion(rKey)[item.key]?'text-success':''">{{ rKey==='r1' ? item.cmdR1 : item.cmdR2 }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 4 (both routers) -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task4Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task4Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task4Done?'#28C76F':'#4a5568'}">4</span>
              <span class="font-semibold text-sm flex-1">IPv6 Interface Configuration</span>
              <span class="text-xs font-medium" :class="task4Done?'text-success':'text-grey'">{{ [r1Completion.ipv6Addr, r2Completion.ipv6Addr].filter(Boolean).length }}/2</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="rKey in ['r1','r2']" :key="'t4-'+rKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ rKey.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getCompletion(rKey).ipv6Addr?'#28C76F':'transparent',border:'2px solid '+(getCompletion(rKey).ipv6Addr?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getCompletion(rKey).ipv6Addr?'text-success':''">ipv6 address {{ rKey==='r1' ? '2001:db8:acca::1/64' : '2001:db8:acca::2/64' }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 5 — Verification (R1) -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(verifyDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:verifyDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:verifyDone?'#28C76F':'#4a5568'}">5</span>
              <span class="font-semibold text-sm flex-1">Verification — R1</span>
              <span class="text-xs font-medium" :class="verifyDone?'text-success':'text-grey'">{{ [r1Completion.pingIPv4, r1Completion.pingIPv6].filter(Boolean).length }}/2</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r1Completion.pingIPv4?'#28C76F':'transparent',border:'2px solid '+(r1Completion.pingIPv4?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="r1Completion.pingIPv4?'text-success':''">ping 192.168.180.30</code>
              </div>
              <div class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r1Completion.pingIPv6?'#28C76F':'transparent',border:'2px solid '+(r1Completion.pingIPv6?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="r1Completion.pingIPv6?'text-success':''">ping ipv6 2001:db8:acca::2</code>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ [r1Completion.saved, r2Completion.saved].filter(Boolean).length }}/2</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="rKey in ['r1','r2']" :key="'s-'+rKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ rKey.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getState(rKey).endDone?'#28C76F':'transparent',border:'2px solid '+(getState(rKey).endDone?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getState(rKey).endDone?'text-success':''">end</code>
                  </div>
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getCompletion(rKey).saved?'#28C76F':'transparent',border:'2px solid '+(getCompletion(rKey).saved?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getCompletion(rKey).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <!-- Right: Terminals -->
      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='r1'" key="r1" id="r1_terminal" :commands="r1Commands" :prompt="r1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R1" />
          <vue-command v-show="sel==='r2'" key="r2" id="r2_terminal" :commands="r2Commands" :prompt="r2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R2" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP =
  'Commands:<br>' +
  '&nbsp;interface e0/1 | int e0/1<br>' +
  '&nbsp;ip address [IP] [mask]<br>' +
  '&nbsp;ipv6 address [IPv6/prefix]<br>' +
  '&nbsp;no shutdown | no shut<br>' +
  '&nbsp;ping [IP] | ping ipv6 [IPv6]<br>' +
  '&nbsp;copy running-config startup-config<br>' +
  '&nbsp;exit | end<br>';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/IPv4_and_IPv6_Connectivity_Sim.png',
      sel: 'r1',
      totalScore: 0,

      // Each item has separate cmd text for R1 and R2 since IPs differ
      task123Items: [
        { key: 'intE01',   cmdR1: 'interface e0/1',                              cmdR2: 'interface e0/1' },
        { key: 'ipv4Addr', cmdR1: 'ip address 192.168.180.17 255.255.255.240',   cmdR2: 'ip address 192.168.180.30 255.255.255.240' },
        { key: 'noShut',   cmdR1: 'no shut',                                      cmdR2: 'no shut' },
      ],

      r1: { mode: 'exec', currentInterface: null, endDone: false },
      r2: { mode: 'exec', currentInterface: null, endDone: false },

      r1Completion: {
        intE01: false, ipv4Addr: false, noShut: false,
        ipv6Addr: false,
        pingIPv4: false, pingIPv6: false,
        saved: false,
      },
      r2Completion: {
        intE01: false, ipv4Addr: false, noShut: false,
        ipv6Addr: false,
        saved: false,
      },

      r1Commands: {
        help:      () => createStdout(HELP),
        enable:    () => createStdout(''),
        configure: (x) => this.iosConfigure(this.r1, x),
        conf:      (x) => this.iosConfigure(this.r1, x),
        exit:      () => this.iosExit(this.r1),
        end:       () => { if (this.r1.mode !== 'exec') this.r1.endDone = true; this.r1.mode = 'exec'; return createStdout(''); },
        interface: (x) => this.iosInt('r1', this.r1Completion, x),
        int:       (x) => this.iosInt('r1', this.r1Completion, x),
        ip:        (x) => this.iosIp('r1', x),
        ipv6:      (x) => this.iosIpv6('r1', x),
        no:        (x) => this.iosNo('r1', x),
        ping:      (x) => this.iosPing(x),
        show:      (x) => this.iosShow('r1', x),
        copy:      (x) => this.iosCopy(this.r1, this.r1Completion, x),
      },
      r2Commands: {
        help:      () => createStdout(HELP),
        enable:    () => createStdout(''),
        configure: (x) => this.iosConfigure(this.r2, x),
        conf:      (x) => this.iosConfigure(this.r2, x),
        exit:      () => this.iosExit(this.r2),
        end:       () => { if (this.r2.mode !== 'exec') this.r2.endDone = true; this.r2.mode = 'exec'; return createStdout(''); },
        interface: (x) => this.iosInt('r2', this.r2Completion, x),
        int:       (x) => this.iosInt('r2', this.r2Completion, x),
        ip:        (x) => this.iosIp('r2', x),
        ipv6:      (x) => this.iosIpv6('r2', x),
        no:        (x) => this.iosNo('r2', x),
        show:      (x) => this.iosShow('r2', x),
        copy:      (x) => this.iosCopy(this.r2, this.r2Completion, x),
      },
    };
  },

  computed: {
    r1Prompt() {
      const m = this.r1.mode;
      if (m === 'config') return 'R1(config)#';
      if (m === 'config-if') return 'R1(config-if)#';
      return 'R1#';
    },
    r2Prompt() {
      const m = this.r2.mode;
      if (m === 'config') return 'R2(config)#';
      if (m === 'config-if') return 'R2(config-if)#';
      return 'R2#';
    },
    task123Progress() {
      return ['intE01','ipv4Addr','noShut'].filter(k => this.r1Completion[k]).length +
             ['intE01','ipv4Addr','noShut'].filter(k => this.r2Completion[k]).length;
    },
    task123Done() {
      const c1 = this.r1Completion; const c2 = this.r2Completion;
      return c1.intE01 && c1.ipv4Addr && c1.noShut && c2.intE01 && c2.ipv4Addr && c2.noShut;
    },
    task4Done() { return this.r1Completion.ipv6Addr && this.r2Completion.ipv6Addr; },
    verifyDone() { return this.r1Completion.pingIPv4 && this.r1Completion.pingIPv6; },
    saveDone()   { return this.r1Completion.saved && this.r2Completion.saved; },
  },

  watch: {
    'r1Completion.noShut'(val) { if (val && !this.r2Completion.noShut) this.switchTo('r2'); },
    'r2Completion.noShut'(val) { if (val && !this.r1Completion.ipv6Addr) this.switchTo('r1'); },
    'r1Completion.ipv6Addr'(val) { if (val && !this.r2Completion.ipv6Addr) this.switchTo('r2'); },
    'r2Completion.ipv6Addr'(val) { if (val && !this.verifyDone) this.switchTo('r1'); },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
  },

  methods: {
    getState(rKey) { return this[rKey]; },
    getCompletion(rKey) { return this[rKey + 'Completion']; },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    switchTo(router) {
      this.sel = router;
      this.$nextTick(() => {
        const el = document.querySelector(`#${router}_terminal input, #${router}_terminal textarea`);
        if (el) el.focus();
      });
    },

    modeErr(state, needed) {
      if (state.mode === needed) return null;
      if (needed === 'config') {
        if (state.mode === 'exec') return createStderr('% Must be in configuration mode — type "configure terminal" first');
        if (state.mode === 'config-if') return createStderr('% Must be in configuration mode — type "exit" to leave interface config first');
      }
      if (needed === 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" or "exit" first');
      if (needed === 'config-if') return createStderr('% Must be in interface config mode — type "interface e0/1" first');
      return createStderr('% Invalid input detected');
    },

    iosConfigure(state, x) {
      const me = this.modeErr(state, 'exec'); if (me) return me;
      if (x._[1] === 'terminal' || x._[1] === 't') {
        state.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(state) {
      if (state.mode === 'config-if') state.mode = 'config';
      else if (state.mode === 'config') { state.mode = 'exec'; state.endDone = true; }
      return createStdout('');
    },

    iosInt(rKey, completion, x) {
      const state = this[rKey];
      const me = this.modeErr(state, 'config'); if (me) return me;
      let _r1 = String(x._[1] || '');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) _r1 = _r1 + x._[2];
      const raw = _r1.toLowerCase()
      const iface = raw.replace(/^(gigabitethernet|ethernet|fastethernet|gi|fa|e|f)/, 'e');
      if (!iface || !iface.match(/^e\d+\/\d+/)) return createStderr('% Invalid interface');
      state.mode = 'config-if';
      state.currentInterface = iface;
      if (iface === 'e0/1' && !completion.intE01) { completion.intE01 = true; this.updateScore(); }
      return createStdout(this.guide(`Entered interface ${iface} configuration mode. → "ip address [IP] 255.255.255.240" to assign the IPv4 address.`));
    },

    iosIp(rKey, x) {
      const state = this[rKey]; const completion = this[rKey + 'Completion'];
      if (x._[1] === 'address') {
        const me = this.modeErr(state, 'config-if'); if (me) return me;
        // Accept correct mask on e0/1; don't enforce exact host IP to avoid minimist parsing edge cases
        if (state.currentInterface === 'e0/1' && x._[3] === '255.255.255.240' && !completion.ipv4Addr) {
          completion.ipv4Addr = true; this.updateScore();
        }
        return createStdout(this.guide('IPv4 address assigned. /28 (255.255.255.240) gives 14 usable hosts. R1 is .17 and R2 is .30 — both in the 192.168.180.16/28 subnet. → "no shut" to bring the interface up.'));
      }
      return createStderr('% Invalid input detected');
    },

    iosIpv6(rKey, x) {
      const state = this[rKey]; const completion = this[rKey + 'Completion'];
      if (x._[1] === 'address') {
        const me = this.modeErr(state, 'config-if'); if (me) return me;
        if (state.currentInterface === 'e0/1' && !completion.ipv6Addr) {
          completion.ipv6Addr = true; this.updateScore();
        }
        return createStdout(this.guide('IPv6 address assigned. Both routers share the 2001:db8:acca::/64 prefix — R1 is ::1 and R2 is ::2. IPv6 and IPv4 can coexist on the same interface (dual-stack).'));
      }
      return createStderr('% Invalid input detected');
    },

    iosNo(rKey, x) {
      const state = this[rKey]; const completion = this[rKey + 'Completion'];
      if (x._[1] === 'shutdown' || x._[1] === 'shut') {
        const me = this.modeErr(state, 'config-if'); if (me) return me;
        if (!completion.noShut) { completion.noShut = true; this.updateScore(); }
        return createStdout(
          '%LINK-5-CHANGED: Interface Ethernet0/1, changed state to up<br>' +
          '%LINEPROTO-5-UPDOWN: Line protocol on Interface Ethernet0/1, changed state to up' +
          this.guide('Interface is now up/up. Both the physical link (Layer 1) and line protocol (Layer 2) are operational. → "exit" then "ipv6 address" on e0/1 for Task 4.')
        );
      }
      return createStderr('% Invalid input detected');
    },

    iosPing(x) {
      const me = this.modeErr(this.r1, 'exec'); if (me) return me;
      // IPv6 ping: ping ipv6 2001:db8:acca::2
      if (x._[1] === 'ipv6') {
        if (!this.r1Completion.pingIPv6) { this.r1Completion.pingIPv6 = true; this.updateScore(); }
        return createStdout(
          'Sending 5, 100-byte ICMP Echos to 2001:DB8:ACCA::2, timeout is 2 seconds:<br>' +
          '!!!!!<br>Success rate is 100 percent (5/5), round-trip min/avg/max = 1/1/1 ms' +
          this.guide('IPv6 ping to R2 successful. Both routers have dual-stack configured — IPv4 and IPv6 operate independently on the same link.')
        );
      }
      // IPv4 ping: ping 192.168.180.30
      if (x._[1] === '192.168.180.30') {
        if (!this.r1Completion.pingIPv4) { this.r1Completion.pingIPv4 = true; this.updateScore(); }
        return createStdout(
          'Sending 5, 100-byte ICMP Echos to 192.168.180.30, timeout is 2 seconds:<br>' +
          '.!!!!<br>Success rate is 80 percent (4/5), round-trip min/avg/max = 1/1/1 ms' +
          this.guide('IPv4 ping to R2 successful. The first packet is often dropped while ARP resolves R2\'s MAC address — 80% (4/5) is expected and normal.')
        );
      }
      return createStdout(`Sending 5 ICMP Echos to ${x._[1]}...<br>.....<br>Success rate is 0 percent (0/5)`);
    },

    iosShow(rKey, x) {
      const state = this[rKey];
      const me = this.modeErr(state, 'exec'); if (me) return me;
      if (x._[1] === 'ip' && x._[2] === 'interface' && x._[3] === 'brief') {
        const c = this[rKey + 'Completion'];
        const ip = rKey === 'r1' ? '192.168.180.17' : '192.168.180.30';
        return createStdout(
          'Interface&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;IP-Address&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OK?&nbsp;Method&nbsp;Status&nbsp;&nbsp;&nbsp;Protocol<br>' +
          `Ethernet0/1&nbsp;&nbsp;${c.ipv4Addr ? ip : 'unassigned'}&nbsp;&nbsp;&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;${c.noShut ? 'up' : 'down'}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${c.noShut ? 'up' : 'down'}<br>` +
          this.guide(c.noShut ? 'Interface is up/up with IPv4 address assigned.' : 'Interface is down — ensure you ran "no shutdown" and assigned an IP address.')
        );
      }
      return createStderr('% Invalid input detected');
    },

    iosCopy(state, completion, x) {
      const me = this.modeErr(state, 'exec'); if (me) return me;
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!completion.saved) { completion.saved = true; this.updateScore(); }
        return createStdout('Building configuration...<br>[OK]' + this.guide('Configuration saved to NVRAM. Running-config holds active settings in RAM; startup-config persists them across reboots.'));
      }
      return createStderr('% Invalid input detected');
    },

    updateScore() {
      let score = 0;
      [this.r1Completion, this.r2Completion].forEach(c => {
        Object.values(c).forEach(v => { if (v) score++; });
      });
      this.totalScore = score;
      this.$emit('simulation_update_score', score);
      if (score >= 12) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#r1_terminal, #r2_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

